export default __webpack_public_path__ + "static/media/GuidelinesEN.ed52a917.pdf";